const desktopTabletChangePanelUI = () => {
    $('.panel-body.closed').css('display', 'block');
    $('.panel-checkout > .panel-heading > h4 ').removeClass('inverse');
    $('.panel-checkout').removeClass('panel-mobile');
};

const mobileChangePanelUI = () => {
    if ($('.panel-body').hasClass('closed')) $('.panel-body.closed').css('display', 'none');
    $('.panel-checkout > .panel-heading > h4 ').addClass('inverse');
    $('.panel-checkout').addClass('panel-mobile');
};

export {
  desktopTabletChangePanelUI,
  mobileChangePanelUI
}
